import { FC } from 'react'

import {
  KeyboardLayoutGrid,
  KeyboardLayoutKey,
  KeyboardLayoutRow,
} from './Keyboard.styles'
import { KeyboardLayoutProps } from './types'

export const KeyboardLayout: FC<KeyboardLayoutProps> = ({
  config,
  onSelect,
  type,
  onGridMove,
  defaultFocusRow,
  defaultFocusColumn,
  focusIdPrefix,
}) => {
  const saveLastPosition = ({
    nextColumnIndex,
    nextRowIndex,
  }: GridMoveEvent) => {
    onGridMove({ col: nextColumnIndex, row: nextRowIndex })
  }

  return (
    <KeyboardLayoutGrid
      defaultFocusRow={defaultFocusRow}
      defaultFocusColumn={defaultFocusColumn}
      isGrid
      onGridMove={saveLastPosition}
    >
      {config.map((row, index) => (
        <KeyboardLayoutRow key={index}>
          {row.map((char) => (
            <KeyboardLayoutKey
              key={`${focusIdPrefix}${type}${char}`}
              focusId={`${focusIdPrefix}char-${char}`}
              elementType="span"
              onSelected={() => onSelect(char)}
            >
              {char}
            </KeyboardLayoutKey>
          ))}
        </KeyboardLayoutRow>
      ))}
    </KeyboardLayoutGrid>
  )
}
